import { Grid, Box, styled } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { Interaction } from 'wisestep-api';
import { WsTypography, WsTypoColors, timeSince, WsColors, getDateUsingFormat } from 'wisestep-base';

import { IStageStatus } from '../WsCandidateCard/WsCandidateCard';
interface ICandidateStageStatusProps {
  interaction?: Interaction;
  stageStatus?: IStageStatus;
}

const CandidateStageStatus = ({ interaction, stageStatus }: ICandidateStageStatusProps) => (
  <>
    {interaction && isEmpty(stageStatus) && (
      <Grid item xs={12} container pl={2} columnGap={2} pb={1}>
        <WsTypography
          hoverText={
            interaction.modifiedOn
              ? getDateUsingFormat(String(interaction.modifiedOn), 'D MMMM YYYY, HH:mm')
              : ''
          }
        >
          {`Last Submission updated  
      ${timeSince(String(interaction.modifiedOn)) ?? 'Not Available'} `}
        </WsTypography>
        {interaction.applicationStage && (
          <SmallBoxWithBgColor>
            <WsTypography color={WsTypoColors.WHITE} bold={true}>
              {interaction.applicationStage}
            </WsTypography>
          </SmallBoxWithBgColor>
        )}
        {interaction.applicationState && (
          <SmallBoxWithBgColor>
            <WsTypography color={WsTypoColors.WHITE} bold={true}>
              {interaction.applicationState}
            </WsTypography>
          </SmallBoxWithBgColor>
        )}
      </Grid>
    )}
    {stageStatus && isEmpty(interaction) && (
      <Grid item xs={12} container pl={2} columnGap={2} pb={1}>
        {stageStatus.applicationStage && (
          <SmallBoxWithBgColor>
            <WsTypography color={WsTypoColors.WHITE} bold={true}>
              {stageStatus.applicationStage}
            </WsTypography>
          </SmallBoxWithBgColor>
        )}
        {stageStatus.applicationState && (
          <SmallBoxWithBgColor>
            <WsTypography color={WsTypoColors.WHITE} bold={true}>
              {stageStatus.applicationState}
            </WsTypography>
          </SmallBoxWithBgColor>
        )}
      </Grid>
    )}
  </>
);

export const SmallBoxWithRadius = styled(Box)(() => ({
  border: '1px solid ',
  borderColor: WsColors.TheBlues500,
  borderRadius: 8,
  paddingLeft: 8,
  paddingRight: 8,
  height: 25,
  alignItems: 'center',
}));
export const SmallBoxWithBgColor = styled(SmallBoxWithRadius)(() => ({
  background: WsColors.TheBlues400,
  borderRadius: 4,
  border: '0px',
}));
export default CandidateStageStatus;
